import { useEffect } from "react";

//default 10 seconds
export const useRedirectHome = (redirectTime = 10000) => {
    useEffect(() => {
        setTimeout(() => {
            window.location.href = process.env.NEXT_PUBLIC_DOMAIN_URL;
        }, redirectTime);
    }, []);
}